import * as React from "react";
import header from './header.jpg';

type Props = {
    location? : string
}

export const Header: React.FC<Props> = props => {
    
  
    return (
      <div>
        <img src={props.location? props.location + header : header} className="header" alt=""/>
      </div>
    )
  }